/**
 * WhatsApp Shipment Status — standalone page under the D2C & PTL dashboards.
 * Shows the shipment-status updates shared with customers over WhatsApp.
 * Laid out to match the dashboard: PageTitle (top bar) + a filter-bar card, no in-body hero.
 */
import React, {useState} from 'react'
import {subDays} from 'date-fns'
import {Box, Typography} from '@mui/material'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import WhatsAppComm from '../dashboard/whatsapp'
import DashboardDateFilter, {DateRangeCaption} from '../../common/DashboardDateFilter'
import PageTitle from '../../common/PageTitle'
import withLayout from '../../hocs/Layout'
import {BORDER, WHITE, NAVY, SUBTLE} from '../../styles/foundation/colors'
import {FONT, SIZE, WEIGHT} from '../../styles/foundation/typography'
import {SHADOW} from '../../styles/foundation/effects'
import {pageContainerSx} from '../../styles/patterns'

function WhatsAppNDR() {
  const [dateRange, setDateRange] = useState([{
    endDate: new Date(), startDate: subDays(new Date(), 7), key: 'selection',
  }])

  return (
    <Box sx={pageContainerSx}>
      <PageTitle subTitle='Shipment status updates shared with customers over WhatsApp — order placed, in-transit, out for delivery, delivered and more'>
        WhatsApp Shipment Status
      </PageTitle>

      {/* Filter bar — Filters + active-range caption on the left, presets + picker on the right. */}
      <Box sx={{
        bgcolor: WHITE, borderRadius: '14px', boxShadow: SHADOW.card,
        border: `1px solid ${BORDER}`, px: 2.5, py: 1.5, mb: 2.5,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5,
      }}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap'}}>
          <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
            <TuneOutlinedIcon sx={{color: SUBTLE, fontSize: 20}} />
            <Typography sx={{fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.semibold, color: NAVY}}>Filters</Typography>
          </Box>
          <DateRangeCaption dateRange={dateRange} />
        </Box>
        <DashboardDateFilter dateRange={dateRange} maxDate={new Date()} onChange={(range) => setDateRange(range)} />
      </Box>

      <WhatsAppComm tab={8} dateRange={dateRange} />
    </Box>
  )
}

export default withLayout(WhatsAppNDR)
